import z from 'zod';
import { OperationSchema } from './operation';
import { zAlias } from '../../shared/zod.helpers';

export const OrganizationSchema = zAlias(
  z.object({
    id: z.string(),
    name: z.string(),
    operations: z.array(OperationSchema)
  }),
  { _id: 'id' }
);

export type Organization = z.infer<typeof OrganizationSchema>;
